module.exports = __webpack_public_path__ + "static/media/plant-crop.298980c2.png";